import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/i18n/LanguageContext';

import { API } from '@/lib/apiBase';

export const TopPhotosTable = ({ topPhotos }) => {
  const { t } = useLanguage();
  if (!topPhotos || topPhotos.length === 0) return null;
  return (
    <Card className="bg-card border-border mb-10">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-4">{t('analytics.topPhotos')}</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left">
                <th className="pb-3 text-muted-foreground font-medium">Photo</th>
                <th className="pb-3 text-muted-foreground font-medium">{t('analytics.purchases')}</th>
                <th className="pb-3 text-muted-foreground font-medium">{t('admin.price')}</th>
                <th className="pb-3 text-muted-foreground font-medium">Type</th>
              </tr>
            </thead>
            <tbody>
              {topPhotos.map((photo) => (
                <tr key={photo.photo_id} className="border-b border-border/50">
                  <td className="py-3">
                    <div className="flex items-center gap-3">
                      <img
                        src={`${API}/photos/${photo.photo_id}/preview?size=thumb`}
                        alt=""
                        className="w-10 h-10 rounded-sm object-cover"
                      />
                      <span className="font-mono text-xs truncate max-w-[200px]">{photo.filename}</span>
                    </div>
                  </td>
                  <td className="py-3 font-bold">{photo.purchases}</td>
                  <td className="py-3 font-mono text-primary">CHF {photo.price.toFixed(2)}</td>
                  <td className="py-3">
                    <span className={`text-xs px-2 py-0.5 rounded-sm ${photo.is_class_photo ? 'bg-blue-500/10 text-blue-400' : 'bg-primary/10 text-primary'}`}>
                      {photo.is_class_photo ? t('gallery.classPhoto') : t('gallery.individualPhotos')}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
